<template>
  <button
    class="menutoggler d-lg-none"
    type="button"
    aria-expanded="false"
    aria-label="Afficher ou masquer le menu de l'application"
    @click="$emit('toggleMenu')"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
</template>

<script>
export default {
  name: "MenuToggler",
  props: {
    blocMarqueConfig: { type: Object, default: () => {} },
    logoConfig: { type: Object, default: () => {} }
  },
  computed: {}
};
</script>
<style scoped>
button.menutoggler {
  cursor: pointer !important;
  padding: 0 0.25rem !important;
  color: rgba(0, 0, 0, 0.55) !important;
  font-size: 1.25rem !important;
  line-height: 1 !important;
  background-color: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 0.25rem !important;
  position: absolute !important;
  left: 0.25rem !important;
  width: auto !important;
  max-width: 2.5rem !important;
  height: auto !important;
  max-height: 2.5rem !important;
}
#applicationHeader__mobile button.menutoggler {
  position: absolute !important;
  left: unset !important;
  right: 0.75rem !important;
  top: 0.25rem !important;
}
</style>